import React from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: "1",
    position: "absolute",
    right: "25px",
    top: "20px",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
  },
  title: {
    fontWeight: "500",
  },
  subheader: {
    fontSize: "1rem",
    lineHeight: "30px",
  },
  contentHeader: {
    paddingLeft: 0,
    paddingTop: 0,
  },
  contentContainer: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
    },
  },
  button: {
    maxHeight: "31px",
    maxWidth: "31px",
    minHeight: "31px",
    minWidth: "31px",
    padding: "6px",
    opacity: "0.4",
    "&$selected": {
      opacity: 1,
      backgroundColor: "#EBEBEB",
      "&:hover": {
        backgroundColor: "#EBEBEB",
      },
    },
  },
  selected: {
    backgroundColor: "#000",
  },
}));

const CardSwitch = (props) => {
  const [alignment, setAlignment] = React.useState("left");

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment == null) {
      return false;
    } else {
      setAlignment(newAlignment);
      props.sendData(newAlignment);
    }
  };

  const classes = useStyles();
  return (
    <ToggleButtonGroup
      className={classes.root}
      aria-label="text alignment"
      value={alignment}
      exclusive
      onChange={handleAlignment}
    >
      <ToggleButton
        className={classes.button}
        classes={{ selected: classes.selected }}
        value="left"
      >
        {props.children[0]}
      </ToggleButton>
      <ToggleButton
        className={classes.button}
        classes={{ selected: classes.selected }}
        value="right"
      >
        {props.children[1]}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default CardSwitch;
